import PropTypes from "prop-types";
import { MODAL_TEXT } from "../../ui/modalStyles";
import ModalCloseX from "../common/ModalCloseX";

export default function ConfirmModal({
  isOpen,
  open,
  onClose,
  onCancel,
  onConfirm,
  title = "Confirm",
  message,
  subMessage,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  cancelText,
  confirmText,
  confirmingLabel,
  isSubmitting = false,
  isBusy = false,
  showClose = true,
  hideCancel = false,
}) {
  const resolvedOpen = isOpen ?? open ?? false;
  if (!resolvedOpen) return null;

  const resolvedSubmitting = isSubmitting || isBusy;
  const resolvedCancelLabel = cancelText || cancelLabel;
  const resolvedConfirmLabel = confirmText || confirmLabel;
  const handleClose = onClose || onCancel || (() => {});

  const confirmTextValue =
    !confirmText && resolvedSubmitting && confirmingLabel
      ? confirmingLabel
      : resolvedConfirmLabel;

  return (
    <div className="fixed inset-0 z-[10050] flex items-center justify-center bg-black/60 px-4 py-6">
      <div
        role="dialog"
        aria-modal="true"
        className={`relative w-full max-w-md h-auto max-h-[80vh] rounded-3xl border border-slate-200 bg-white shadow-2xl overflow-hidden flex flex-col ${MODAL_TEXT}`}
      >
        <div className="flex items-center justify-between bg-rose-500 px-6 py-4">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            {title}
          </h2>
          {showClose ? <ModalCloseX onClick={handleClose} /> : null}
        </div>
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-160px)]">
          <div className="text-sm text-slate-700 space-y-2">
            {message && <p>{message}</p>}
            {subMessage && <p>{subMessage}</p>}
          </div>
        </div>
        <div className="border-t border-slate-200 px-6 py-4 flex-shrink-0">
          <div className="flex justify-end gap-2">
            {!hideCancel ? (
              <button
                type="button"
                className="rounded-full border border-slate-300 px-5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
                onClick={handleClose}
                disabled={resolvedSubmitting}
              >
                {resolvedCancelLabel}
              </button>
            ) : null}
            <button
              type="button"
              onClick={onConfirm}
              disabled={resolvedSubmitting}
              className="rounded-full bg-rose-500 px-5 py-2 text-sm font-semibold text-white hover:bg-rose-600 disabled:opacity-60"
            >
              {confirmTextValue}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.node,
  subMessage: PropTypes.node,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  confirmingLabel: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isBusy: PropTypes.bool,
  showClose: PropTypes.bool,
  hideCancel: PropTypes.bool,
};
